import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SilentCallbackComponent implements OnInit {
  readonly #router = inject(Router);
  readonly #authService = inject(AuthService);

  ngOnInit() {
    this.#authService
      .signinCallback()
      .then()
      .catch(() => {
        this.#router.navigate(['not-found']);
      });
  }
}
